module.exports = __webpack_public_path__ + "img/reglementaire-colored.a8ddaaed.svg";